import { Fragment } from "react";
import Dropdown from "../Navbar/Dropdown";
import { Link } from "react-router-dom";

const Logo = () => {
  return (
    <Fragment>
      <div className="absolute right-0">
        <Dropdown />
      </div>
      <br />
      <Link to="/">
        <img
          src="/img/Inshindo logo.png"
          alt="logo"
          className="mx-auto h-[113px]"
        />
      </Link>
    </Fragment>
  );
};

export default Logo;
